export const BUILT_IN_FIELDS_ORDERING = [
  "first_name",
  "last_name",
  "address_line_1",
  "address_line_2",
  "city",
  "state",
  "zip",
];

/**
 * Sorts audience contact fields by built-in fields ordering, then by name alphabetical (NOT in place).
 * @param fields The audience contact fields to sort.
 * @returns A new array of sorted audience contact fields.
 */
export function sortContactFields<T extends { name: string }>(
  fields: T[]
): T[] {
  return [...fields].sort((a, b) => {
    const aIndex = BUILT_IN_FIELDS_ORDERING.indexOf(a.name);
    const bIndex = BUILT_IN_FIELDS_ORDERING.indexOf(b.name);
    if (aIndex !== -1 && bIndex !== -1) {
      return aIndex - bIndex;
    }
    if (aIndex !== -1) {
      return -1;
    }
    if (bIndex !== -1) {
      return 1;
    }
    return a.name.localeCompare(b.name);
  });
}
